import styled from 'styled-components'
import { DEVICE } from '../../../util/constants'
import { Link } from 'gatsby'

export const PodcastGreyFrame = styled.div`
  width: 100%;
  background-color: var(--content-background-light);
  margin-top: 38px;
  margin-bottom: 30px;
`

export const PodcastEmbedBlock = styled.div`
  margin: 33px 30px 13px;
  grid-column: span 3;
  grid-row: 1;

  iframe {
    height: ${({ playerHeight }) => playerHeight}px;
  }
`

export const LinkRow = styled.div`
  grid-column: 2 / 3;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  margin-bottom: 20px;
  @media ${DEVICE.laptopG} {
    grid-column: unset;
    margin-left: 30px;
    margin-right: 30px;
  }
`

export const NextPodcastLink = styled(Link)`
  margin-top: 5px;
  grid-column: 2 / 12;
  display: flex;
  flex-direction: row;
  align-items: center;
  text-decoration-line: none;
  font-style: normal;
  font-weight: bold;
  font-size: 1.4rem;
  line-height: 1.71;
  letter-spacing: 0.02em;
  color: var(--highlight-blue);
  margin-left: auto;

  :hover {
    text-decoration-line: underline;
  }

  span {
    padding-right: 5px;
  }
`
